module.exports = __webpack_public_path__ + "static/programming-2b914366ab644366da349d215ada93f4.jpg";